__turbopack_context__.v({
  "className": "KlW4aa_className",
  "variable": "KlW4aa_variable",
});
